
import type { PropOptions } from 'vue';
import Vue from 'vue';
import type { PublicPortfolioConfiguration, Testimonial } from '@/types/graphql';
import type { SectionMode } from '~/components/partials/public-portfolio/types';
import PublicPortfolioTestimonial from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/PublicPortfolioTestimonial.vue';
import PublicPortfolioTestimonialModal from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/PublicPortfolioTestimonialModal.vue';
import PublicPortfolioRequestTestimonialsModal from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/PublicPortfolioRequestTestimonialModal.vue';
import PublicPortfolioRequestTestimonialSuccessModal from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/PublicPortfolioRequestTestimonialSuccessModal.vue';
import PublicPortfolioApproveTestimonialSuccessModal from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/PublicPortfolioApproveTestimonialSuccessModal.vue';
import PublicPortfolioEditTestimonialsModal from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/PublicPortfolioEditTestimonialsModal.vue';
import PublicPortfolioApproveTestimonialModal from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/PublicPortfolioApproveTestimonialModal.vue';
import PublicPortfolioTestimonialScreenshotModal from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/PublicPortfolioTestimonialScreenshotModal.vue';
import type { PublicPortfolioTestimonialPropMixinType } from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/mixins/publicPortfolioTestimonialPropMixin';
import publicPortfolioTestimonialPropMixin from '~/components/partials/public-portfolio/PublicPortfolioTestimonials/mixins/publicPortfolioTestimonialPropMixin';

interface IData {
  previewTestimonial: { authorName: string; testimonialText: string };
  dummyTestimonials: Array<Partial<Testimonial>>;
}

export default (Vue as PublicPortfolioTestimonialPropMixinType).extend({
  name: 'PublicPortfolioTestimonialsSection',
  components: {
    PublicPortfolioTestimonialScreenshotModal,
    PublicPortfolioApproveTestimonialModal,
    PublicPortfolioEditTestimonialsModal,
    PublicPortfolioRequestTestimonialSuccessModal,
    PublicPortfolioApproveTestimonialSuccessModal,
    PublicPortfolioRequestTestimonialsModal,
    PublicPortfolioTestimonialModal,
    PublicPortfolioTestimonial,
    BravadoSwiper: () =>
      import(/* webpackChunkName: "bravadoSwiper" */ '~/components/common/BravadoSwiper/BravadoSwiper.vue'),
  },
  mixins: [publicPortfolioTestimonialPropMixin],
  props: {
    mode: { type: String, default: 'view' } as PropOptions<SectionMode>,
    testimonials: {
      type: Array,
      required: true,
    } as PropOptions<Array<Testimonial>>,
    testifySign: {
      type: String,
      default: '',
    } as PropOptions<string>,
    configuration: {
      type: Object,
      required: true,
    } as PropOptions<PublicPortfolioConfiguration>,
  },
  data(): IData {
    return {
      previewTestimonial: {
        authorName: '',
        testimonialText: '',
      },
      dummyTestimonials: [
        {
          author: {
            firstname: 'Sahil',
            lastname: 'Mansuri',
            avatarUrl: require('./assets/sahil.png'),
            jobTitle: 'CEO at Bravado',
          },
          description:
            'Imagine Sahil is a past customer. And you requested a testimonial from him and he wrote up a quick blurb about why you’re great to work with. Now, imagine a prospect, seeing Sahil’s testimonial, thinking that you are a great salesperson they might want to buy from. That’s the power of testimonials.',
        },
        {
          author: {
            firstname: 'Ross',
            lastname: 'Pomerantz',
            jobTitle: 'Head of community at Bravado',
            avatarUrl: require('./assets/ross.png'),
          },
          description:
            'Remember that time you sold to Corp? He was a total pain but you managed to close the deal? He was certainly impressed. Now, his testimonial about your professionalism lives here, which prospective customers can see. A good testimonial is the difference between them buying from you and from the competitor.',
        },
      ],
    };
  },
  methods: {
    showTestimonialPreview(testimonial: Partial<Testimonial>) {
      if (testimonial.author) {
        this.previewTestimonial = {
          authorName: this.getAuthorName(testimonial.author),
          testimonialText: testimonial.description || '',
        };
        this.$router.push(`?dynamic_modal=${this.$constants.dynamicModals.PUBLIC_PORTFOLIO_TESTIMONIAL_MODAL}`);
      }
    },
  },
});
